import type { RootState } from '@/redux';
type Translations = Record<string, string>;
import type { Campaign } from '@/services/api/types';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export const state = { translations: {}, gameIndex: 0 } as CampaignState;

export type CampaignState = Omit<Campaign, 'translations'> & {
  translations: Translations;
  currentTime?: string | null;
  serverTime?: string | null;
  gameIndex?: number;
};

export const {
  reducer,
  actions: {
    setCampaignData,
    setCampaignGameIndex,
    setCampaignServerTime,
    setCampaignCurrentTime,
    setCampaignTranslations
  }
} = createSlice({
  initialState: state,
  name: 'campaign',
  reducers: {
    setCampaignData: (_, action: PayloadAction<CampaignState>) =>
      action.payload,

    setCampaignGameIndex: (state, action: PayloadAction<number>) => ({
      ...state,
      gameIndex: action.payload
    }),

    setCampaignServerTime: (state, action: PayloadAction<string | null>) => ({
      ...state,
      serverTime: action.payload
    }),

    setCampaignCurrentTime: (state, action: PayloadAction<string | null>) => ({
      ...state,
      currentTime: action.payload
    }),

    setCampaignTranslations: (state, action: PayloadAction<Translations>) => ({
      ...state,
      translations: action.payload
    })
  }
});

const getGameIndex = (state: RootState) => state.campaign.gameIndex ?? 0;

export const getCampaignId = (state: RootState) => state.campaign.id;

export const getCampaignTranslations = (state: RootState) =>
  state.campaign.translations;

export const getCampaignCurrentTime = (state: RootState) =>
  state.campaign.currentTime;

export const getCampaignServerTime = (state: RootState) =>
  state.campaign.serverTime;

export const getCampaignTimezone = (state: RootState) =>
  state.campaign.timezone;

export const getCampaignGameId = (state: RootState) =>
  state.campaign.campaignGames?.[getGameIndex(state)].id;

export const getCampaignGames = (state: RootState) =>
  state.campaign.campaignGames;

export const getCampaignGame = (state: RootState) =>
  state.campaign.campaignGames?.[getGameIndex(state)];
